import { createSlice } from "@reduxjs/toolkit";
import { loadCart, saveCart } from "./cartStorage";

const MAX_QTY = 3;

const initialState = {
  items: loadCart(),
  isOpen: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;

      const exist = state.items.find(
        (i) => i._id === item._id
      );

      if (exist) {
        if (exist.qty < MAX_QTY) {
          exist.qty += 1;
        }

       
        exist.note = item.note || exist.note;
        exist.image = item.image || exist.image;
      } else {
        state.items.push({
          _id: item._id,
          name: item.name,
          price: item.price,
          image: item.image,
          note: item.note || "NO_NOTE",
          qty: 1,
        });
      }

      saveCart(state.items);
      state.isOpen = true;
    },

    increment: (state, action) => {
      const item = state.items.find(
        (i) => i._id === action.payload._id
      );

      if (item && item.qty < MAX_QTY) {
        item.qty += 1;
      }

      saveCart(state.items);
    },

    decrement: (state, action) => {
      const index = state.items.findIndex(
        (i) => i._id === action.payload._id
      );

      if (index !== -1) {
        if (state.items[index].qty > 1) {
          state.items[index].qty -= 1;
        } else {
          state.items.splice(index, 1);
        }
      }

      saveCart(state.items);
    },

    removeFromCart: (state, action) => {
      state.items = state.items.filter(
        (i) => i._id !== action.payload._id
      );
      saveCart(state.items);
    },

    clearCart: (state) => {
      state.items = [];
      saveCart([]);
    },

    openCart: (state) => {
      state.isOpen = true;
    },

    closeCart: (state) => {
      state.isOpen = false;
    },
  },
});

export const {
  addToCart,
  increment,
  decrement,
  removeFromCart,
  clearCart,
  openCart,
  closeCart,
} = cartSlice.actions;

export default cartSlice.reducer;
